(ns guidebook.views.review
  (:require
    [very.re-frame.core :as rf]
    [guidebook.common :as gc]
    [css.core :refer [defstyled]]
    [cljss.core :as cljss]))

(defstyled review-s :div
  {:min-height "100vh"
   :padding "150px 0"
   :margin "0 0 0 50px"
   :display "grid"
   :grid-template-columns "55%"
   :justify-content "flex-end"
   :align-items "center"
   ::cljss/media {[:print]
                  {:margin "0"
                   :padding "0 0 150px"
                   :align-items "flex-start"
                   :grid-template-columns "75%"}}})

(defstyled background-s :div
  {:position "absolute"
   :background-image "url(/assets/sunset.png)"
   :background-repeat "no-repeat"
   :background-position "center"
   :background-size "cover"
   :top "0"
   :left "50px"
   :right "0"
   :bottom "0"
   ::cljss/media {[:print]
                  {:top "50px"
                   :right "50px"
                   :left "0"
                   :background-position "left center"}}})

(defstyled review-block-s :div
  {:background "black"
   :position "relative"
   :padding "82px 100px"})

(defstyled review-content-s :div
 {:display "grid"
  :grid-gap "4rem"})

(defstyled text-s :p
  {:color "white"
   :font-size (with-meta #(if % "25px" "22px") :question?)
   :font-weight (with-meta #(if % "300" "500") :question?)
   :margin (with-meta #(if % "0" "1.25rem 0 0") :question?)
   :line-height (with-meta #(if % "36px" "32px") :question?)
   ::cljss/media {[:print]
                  {:font-size (with-meta #(if % "20px" "18px") :question?)
                   :margin (with-meta #(if % "0" "1rem 0 0") :question?)
                   :line-height (with-meta #(if % "32px" "28px") :question?)}}})

(defn main []
  (let [d (rf/subscribe [:guidebook/review])]
    (fn []
      [:div
       [background-s]
       [review-s
        [review-block-s
         [gc/title-s {:color "white"} "What's New"]
         [review-content-s
          [:div
           [text-s {:question? true} "What is the most memorable thing that's happened over the past 12 months?"]
           [text-s (:memorable-events @d)]]
          [:div
           [text-s {:question? true} "What life decisions are you contemplating for the next 1, 5, and 10 years? Do any of these keep you up at night?"]
           [text-s (:life-decisions @d)]]
          [:div
           [text-s {:question? true} "What are your goals for this meeting? What specifically do you want to make sure we discuss?"]
           [text-s (:meeting-agenda @d)]]]]]])))
